// @ts-nocheck
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { EXAM_CONFIGURATION_CONFIGS } from 'constants/Exam.constants';
import _ from 'lodash';
import {
  type TExamInCoreSettings,
  fetchExamInCoreSettings,
  updateConfigureFieldLocal,
  updateEnabledLocal,
} from 'slices/examInCoreSettings.slice';
import {
  fetchObjectExtTypes,
  fetchReservationMapping,
  fetchReservationSituations,
  reservationSettingsSelector,
} from 'slices/reservationSettings.slice';
import { useAppDispatch } from 'slices/store';
import { Icon } from '@timeedit/ui-components';
import {
  Col,
  Form,
  Row,
  Switch,
  Tooltip,
  Typography,
} from '@timeedit/ui-components/antd';
import ConfigFieldItem from './ConfigFieldItem';
import './ExamInCoreConfiguration.scss';

const formItemLayout = {
  labelCol: {
    xs: { span: 6 },
    sm: { span: 6 },
    style: {
      textAlign: 'left',
    },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 },
  },
};

// Severity icons from ui-components are self-coloured via theme tokens; only size them.
const iconStyle = {
  fontSize: '23px',
  verticalAlign: 'middle',
};

const ExamInCoreConfiguration = ({
  appSettings,
}: {
  appSettings: TExamInCoreSettings;
}) => {
  const { examInCore } = appSettings;
  const [isExamIdConfigured, setExamIdConfigured] = useState(false);
  const [form] = Form.useForm();
  const dispatch = useAppDispatch();
  const reservationSettings = useSelector(reservationSettingsSelector);

  useEffect(() => {
    dispatch(fetchExamInCoreSettings());
    dispatch(fetchReservationSituations());
    dispatch(fetchObjectExtTypes());
    dispatch(fetchReservationMapping());
  }, []);

  useEffect(() => {
    if (!reservationSettings || !reservationSettings.length) return;
    const examIdField =
      reservationSettings.find(
        (config: any) => config.appFieldId === 'exam_id'
      ) || {};
    setExamIdConfigured(!!examIdField.fieldExt);
  }, [reservationSettings]);

  const handleOnChange = (value: boolean) => {
    dispatch(updateEnabledLocal(value));
  };

  const handleConfigureField = ({ config, type, value }) => {
    dispatch(updateConfigureFieldLocal({ config, type, value }));
  };

  const fields = EXAM_CONFIGURATION_CONFIGS.map(
    ({ label, config, className }) => ({
      label,
      config,
      className,
      value: _.get(examInCore, `configureFields.${config}`, {}),
    })
  );

  return (
    <div className="exam-in-core-configuration-container">
      <Form {...formItemLayout} colon={false} form={form}>
        <Form.Item label="Enable TE Exam in TE Core" name="isEnabled">
          <Switch
            onChange={handleOnChange}
            valuePropName="checked"
            checked={_.get(examInCore, 'isEnabled', false)}
          />
        </Form.Item>
        <Form.Item label="Exam ID field is configured">
          {isExamIdConfigured ? (
            <Icon id="Success" alt="Exam ID configured" style={iconStyle} />
          ) : (
            <Tooltip title="Exam ID hasn't been configured">
              <Icon
                id="Warning"
                alt="Exam ID not configured"
                style={iconStyle}
              />
            </Tooltip>
          )}
        </Form.Item>
        <Typography.Title level={4} style={{ marginTop: 30 }}>
          Configure fields
        </Typography.Title>
        <Row gutter={[16, 8]}>
          <Col span={3} />
          <Col span={7}>
            <p>Select source for Field:</p>
          </Col>
          <Col span={7}>
            <p>Select type or reservation mode:</p>
          </Col>
          <Col span={7}>
            <p>Select fields:</p>
          </Col>
        </Row>
        {fields &&
          fields.map(({ label, config, className }, index) => (
            <ConfigFieldItem
              key={index}
              label={label}
              config={config}
              className={className}
              handleConfigureField={handleConfigureField}
            />
          ))}
      </Form>
    </div>
  );
};
export default ExamInCoreConfiguration;
